<template>
    <div class="content">
        <div class="my-title">
            <Row :gutter="10">
                <Col :span="18">我的订单</Col>
                <Col :span="6">
                    <Select v-model="params.bizId" @on-change="getList(1)">
                        <Option value="JIANGONG_EMPLOYER_LIABILITY">建工雇主</Option>
                        <Option value="JIANGONG_DEPOSIT">建工投标保证金 </Option>
                    </Select>
                </Col>
            </Row>
        </div>
        <Tabs v-model="status">
            <TabPane label="全部订单" name="ALL"></TabPane>
            <TabPane label="待支付" name="UNPAID"></TabPane>
            <TabPane label="已支付" name="PAID"></TabPane>
            <TabPane label="已关闭" name="CLOSED"></TabPane>
        </Tabs>
        <div class="orders">
            <OrderItem v-for="(item,index) in list.data" :key="index" :info="item" @on-load="getList" />
            <div class="nothing" v-if="list.data&&list.data.length==0">暂无数据</div>
            <div class="page">
                <Page :total="list.total" show-total @on-change="getList" />
            </div>
        </div>
    </div>
</template>
<script>
    // import UploadInsurance from '../common/customized/UploadInsurance'
    import OrderItem from '../common/customized/OrderItem'
    import { mapState } from 'vuex'
    export default {
        components: { OrderItem },
        data () {
            return {
                params: {
                    bizId:'JIANGONG_EMPLOYER_LIABILITY'
                },
                status: 'ALL',
                list: {},
                page: 1,
                companyList: []
            }
        },
        watch: {
            status (v) {
                this.getList()
            },
            userInfo (v) {
                this.checkLogin()
            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.common.info
            }),
        },
        created () {
            if(this.$route.query.bizId){
                this.params.bizId = this.$route.query.bizId
            }
            if (this.checkLogin()) {
                this.getList();
                this.getCompanyList();
            }
        },
        methods: {
            // 检测登录
            checkLogin () {
                if (!this.userInfo.userId) {
                    if (location.href && location.href.indexOf('/common.html#/login') == -1) {
                        window.location = location.origin + '/common.html#/login?bankUrl=' + encodeURIComponent(location.href);
                    }
                    return false
                } else {
                    return true
                }
            },
            // 获取服务商列表
            getCompanyList () {
                this.$axios.get('/broker/enterprise/findHaveBind').then(res => {
                    this.companyList = res;
                }).catch(e => {
                    console.log(e)
                });
            },
            getList (page = 1) {
                let form = {
                    page,
                    count: 10,
                    orderStatus: this.status == 'ALL' ? '' : this.status,
                    bizId: this.params.bizId
                };
                this.$axios.post('/broker/order/list.json.all', form).then(res => {
                    this.page = page;
                    this.list = res
                })
            }
        },
    }
</script>
<style scoped lang="less">
    .content {
        padding: 0 15px 15px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customized/order.vue